export const ACTION_TYPE = 'actionType';
export const STATUS = 'status';
export const EMAIL = 'email';
export const SUBJECT = 'subject';
export const COMMENTS = 'comments';
export const PRIORITY = 'priority';
export const DAYS_FROM = 'daysFrom';